<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Seguimiento Operativo - Financiación de Vivienda</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="RegresarOperativo()">Volver</button>
        </div>
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="peridoPorAnioMes()" [(ngModel)]="anioConsulta">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="peridoPorAnioMes()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <div class="row" style="margin-top: 3px;">
        <div class="col-3" style="text-align: center;margin: auto;">
          <label style="margin-top: 4px; font-size: large; color: black;"><b>Periodo {{PeriodoSeleccionado.consecutivoPeriodo}} del {{PeriodoSeleccionado.anio}}</b></label>
        </div>
      </div>
      <br>
      <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="panel1-tab" data-bs-toggle="tab" data-bs-target="#panel1" type="button" role="tab" aria-controls="ic" aria-selected="true">
              <b style="color: black;">Estado avance a la fecha</b>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="panel2-tab" data-bs-toggle="tab" data-bs-target="#panel2" type="button" role="tab" aria-controls="icif" aria-selected="false">
              <b style="color: black;">Grafico avance a la fecha</b>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="panel3-tab" data-bs-toggle="tab" data-bs-target="#panel3" type="button" role="tab" aria-controls="icri" aria-selected="false">
              <b style="color: black;">Tabla de fuentes</b>
            </button>
          </li>
        </ul>
        <div class="tab-content border" id="myTabContent">
          <div class="tab-pane fade show active" id="panel1" role="tabpanel" aria-labelledby="home-tab">
            <div>
              <table class="table table-bordered" style="max-width: 400px; font-size: 100%; margin-top: 2%; margin-bottom: 2%; margin-left: auto; margin-right: auto;">
                <tbody>
                  <tr>
                    <td><b>Días operativo</b></td>
                    <td style="text-align: center;">{{DatosPanel1.diasOperativo}}</td>
                  </tr>
                  <tr>
                    <td><b>Días X % de avance esperado</b></td>
                    <td style="text-align: center;">{{DatosPanel1.avanceEsperado}} %</td>
                  </tr>
                  <tr>
                    <td><b>% Avance real</b></td>
                    <td style="text-align: center;">{{DatosPanel1.avanceReal}} %</td>
                  </tr>
                  <tr>
                    <td rowspan="3"><b>Estado avance a la fecha</b></td>
                    <td *ngIf="DatosPanel1.estado==1" style="background-color: orange;text-align: center;">En Tiempo</td>
                    <td *ngIf="DatosPanel1.estado!=1" style="text-align: center;">En Tiempo</td>
                  </tr>
                  <tr>
                    <td *ngIf="DatosPanel1.estado==2" style="background-color: red;text-align: center;">Atrasado</td>
                    <td *ngIf="DatosPanel1.estado!=2" style="text-align: center;">Atrasado</td>
                  </tr>
                  <tr>
                    <td *ngIf="DatosPanel1.estado==3" style="background-color: green;text-align: center;">Adelantado</td>
                    <td *ngIf="DatosPanel1.estado!=3" style="text-align: center;">Adelantado</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="tab-pane fade" id="panel2" role="tabpanel" aria-labelledby="profile-tab">
            <div style="margin: auto;">
              <div id="myPlotlyDiv" name="myPlotlyDiv" style="width: 800px; max-height: 400px; margin-left: auto; margin-right: auto;"><!-- Plotly chart will be drawn inside this DIV --></div>
            </div>
          </div>
          <div class="tab-pane fade" id="panel3" role="tabpanel" aria-labelledby="contact-tab">
            <div class="col-1" style="margin-top: 1%;">
              <button type="button" class="btn btn-success" style="text-align: center;" (click)="exportarExcel()"><i class="fas fa-download"></i> Excel</button>
            </div>
            <div id="tabla" class="container-fluid overflow-scroll" style="max-width: 80%; margin-left: auto; margin-right: auto; margin-top: 1%;">
              <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable" id="table2excel" style="font-size: 100%;">
                <thead>
                  <tr>
                    <th scope="col" class="text-center">Código entidad</th>
                    <th scope="col" class="text-center">Razón social</th>
                    <th scope="col" class="text-center">Estado información</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let d of DatosPanel3">
                    <td scope="col" >{{d.codigoEntidad}}</td>
                    <td scope="col" >{{d.razonSocial}}</td>
                    <td scope="col" >{{d.estado}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br>
    </div>
  </div>
</body>
